import { Link } from "react-router-dom";

const footerNav = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "话题库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                吃
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料吃话</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-secondary-200">
              一个专注娱乐热点深度解读的内容站。我们不做情绪站队，只把细节、时间线与多方观点摆出来，帮你在信息碎片里看清事件的轮廓。
            </p>
            <p className="mt-5 text-sm text-secondary-200">
              合作与投稿：
              <a
                href="mailto:contact@heiliaochihua.example"
                className="ml-1 text-accent-300 underline-offset-4 hover:underline"
              >
                contact@heiliaochihua.example
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base font-semibold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="cursor-pointer text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base font-semibold text-background-50">栏目方向</h3>
            <ul className="mt-4 grid grid-cols-2 gap-3 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-search-eye-line text-accent-300"></i>深扒解读
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-film-line text-accent-300"></i>幕后逻辑
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-links-line text-accent-300"></i>人物关系
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-focus-3-line text-accent-300"></i>细节复盘
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-pulse-line text-accent-300"></i>舆论观察
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-300"></i>
                <Link to="/contact" className="cursor-pointer hover:text-accent-300">
                  线索投稿
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center">
          <p>© 2026 黑料吃话 · 内容为脱敏化案例分析，不指向现实具体个人</p>
          <p>理性吃瓜 · 尊重事实 · 拒绝站队</p>
        </div>
      </div>
    </footer>
  );
}